import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import Background from './Background';
import AdminHeader from './AdminHeader';
import QaSidebar from './QaSidebar';
import MainContent from './MainContent';
import Footer from './Footer';
import { useSidebarCollapsed } from '../../hooks';

interface QaLayoutProps {
  children: React.ReactNode;
}

// 1:1 with AdminLayout — same Background/Header/MainContent/Footer, only the sidebar is QaSidebar.
// AdminHeader is role-agnostic (logo + back-to-dashboard + user menu), so it's reused as-is.
const QaLayout: React.FC<QaLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  // «Вернуться в кабинет» не влезла в шапку → показываем её первым пунктом меню
  const [backInMenu, setBackInMenu] = useState(false);
  // Свёрнутый сайдбар отдаёт место контенту — как в админке
  const { collapsed: sidebarCollapsed, toggle: toggleSidebar } = useSidebarCollapsed('qaSidebarCollapsed');

  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Background>
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <AdminHeader
          onDrawerToggle={handleDrawerToggle}
          onBackHiddenChange={setBackInMenu}
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={toggleSidebar}
        />
        <QaSidebar
          mobileOpen={mobileOpen}
          onDrawerToggle={handleDrawerToggle}
          showBackToDashboard={backInMenu}
          collapsed={sidebarCollapsed}
        />
        {/* fullWidth только на десктопе по смыслу: на мобиле MainContent и так во всю ширину */}
        <MainContent fullWidth={sidebarCollapsed}>{children}</MainContent>
      </div>
      <Footer />
    </Background>
  );
};

export default QaLayout;
